import './amplify-config';

const config = {
  apiURL: import.meta.env.VITE_API_URL || 'https://localhost:3001/api',
};
export default config;
